export default {"src":"/_next/static/media/orangeDownArrow.05194635.svg","height":10,"width":16};